import React from 'react';
import PropTypes from 'prop-types';

import styles from './FlashDialog.scss';
import Button from 'Components/Button';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

const FlashDialog = ({
  question,
  yesLabel,
  yesCallback,
  noLabel,
  noCallback,
}) => {
  return (
    <div className="FlashDialog">
      <div className="FlashDialog__question">{question}</div>
      {yesCallback ? (
        <Button
          buttonType="flash-dialog"
          additionalClasses=" FlashDialog__button"
          clickHandler={yesCallback}
          label={yesLabel}
        />
      ) : null}
      {noCallback ? (
        <Button
          buttonType="flash-dialog"
          className=" FlashDialog__button"
          clickHandler={noCallback}
          label={noLabel}
        />
      ) : null}
    </div>
  );
};

FlashDialog.propTypes = {
  question: PropTypes.node.isRequired,
  yesLabel: PropTypes.node,
  yesCallback: PropTypes.func.isRequired,
  noLabel: PropTypes.node,
  noCallback: PropTypes.func.isRequired,
};

FlashDialog.defaultProps = {
  yesLabel: <ConnectedFormattedMessage id="flash_dialog.yes_label" />,
  noLabel: <ConnectedFormattedMessage id="flash_dialog.no_label" />,
};

export default FlashDialog;
